const VIRTUAL_GIFTS_REQUEST = 'VIRTUAL_GIFTS_REQUEST';
const VIRTUAL_GIFTS_SUCCESS = 'VIRTUAL_GIFTS_SUCCESS';
const VIRTUAL_GIFTS_ERROR = 'VIRTUAL_GIFTS_ERROR';

import {BobTVUser} from 'bobtvuser';
import * as backend from 'backend-helpers/virtualGifts';

const defaultState = {
    giftCatalogItems: [],
    user: new BobTVUser({nick: ''})
};

export default function virtualGifts(state = defaultState, action) {
    if (action.type === VIRTUAL_GIFTS_SUCCESS) {
        let {giftCatalogItems, user} = action.result;

        return {
            giftCatalogItems,
            user: new BobTVUser(user)
        }
    }

    return state;
}

export function getVirtualGifts(nick) {
    return {
        types: [VIRTUAL_GIFTS_REQUEST, VIRTUAL_GIFTS_SUCCESS, VIRTUAL_GIFTS_ERROR],
        promise: backend.getVirtualGifts({nick})
    }
}


// WEBPACK FOOTER //
// ./src/reducers/virtualGifts.js